module.exports = __webpack_public_path__ + "static/media/ben.2dbf6390.jpg";